const indexItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20scene%2C%20student%20couple%20walking%20in%20school%20hallway%2C%20warm%20sunlight%20through%20windows%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20digital%20illustration%2C%20dreamy%20atmosphere&width=400&height=280&seq=index-manhwa-01&orientation=landscape',
    title: '校园恋爱合集',
    count: '328',
    tag: '热门',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20world%20landscape%2C%20floating%20islands%20with%20castles%2C%20magical%20atmosphere%2C%20warm%20golden%20sunset%2C%20digital%20painting%2C%20epic%20scale&width=400&height=280&seq=index-manhwa-02&orientation=landscape',
    title: '异世界转生合集',
    count: '251',
    tag: '人气',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20scene%2C%20foggy%20city%20street%20at%20night%20with%20street%20lamps%2C%20noir%20aesthetic%2C%20warm%20amber%20glow%2C%20digital%20illustration%2C%20atmospheric&width=400&height=280&seq=index-manhwa-03&orientation=landscape',
    title: '悬疑推理合集',
    count: '196',
    tag: '新晋',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20scene%2C%20modern%20workspace%20with%20people%20working%2C%20bright%20natural%20light%2C%20warm%20cream%20and%20coral%20color%20palette%2C%20digital%20illustration&width=400&height=280&seq=index-manhwa-04&orientation=landscape',
    title: '职场都市合集',
    count: '142',
    tag: '',
    tagColor: '',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20palace%20scene%2C%20traditional%20Korean%20hanbok%20characters%20in%20ancient%20palace%2C%20warm%20lantern%20lighting%2C%20digital%20illustration%2C%20elegant%20atmosphere&width=400&height=280&seq=index-manhwa-05&orientation=landscape',
    title: '古风宫斗合集',
    count: '118',
    tag: '',
    tagColor: '',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20scene%2C%20martial%20arts%20fighter%20in%20dynamic%20pose%2C%20warm%20red%20and%20orange%20energy%20effects%2C%20digital%20illustration%2C%20intense%20atmosphere&width=400&height=280&seq=index-manhwa-06&orientation=landscape',
    title: '热血动作合集',
    count: '105',
    tag: '',
    tagColor: '',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20healing%20slice%20of%20life%20scene%2C%20cozy%20cafe%20with%20sunlight%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20peaceful%20atmosphere%2C%20digital%20illustration&width=400&height=280&seq=index-manhwa-07&orientation=landscape',
    title: '治愈日常合集',
    count: '96',
    tag: '推荐',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20scene%2C%20ancient%20ruins%20with%20mysterious%20glowing%20portal%2C%20deep%20crimson%20and%20violet%20color%20palette%2C%20digital%20art%2C%20atmospheric%20lighting&width=400&height=280&seq=index-manhwa-08&orientation=landscape',
    title: '黑暗奇幻合集',
    count: '89',
    tag: '',
    tagColor: '',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20fantasy%20garden%20scene%2C%20princess%20and%20knight%20in%20rose%20garden%2C%20warm%20golden%20afternoon%20light%2C%20digital%20illustration%2C%20dreamy%20atmosphere&width=400&height=280&seq=index-manhwa-09&orientation=landscape',
    title: '恋爱奇幻合集',
    count: '78',
    tag: '',
    tagColor: '',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">韩漫索引</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按题材分类浏览布丁漫画全部韩漫资源，快速找到感兴趣的专题合集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group relative rounded-xl overflow-hidden cursor-pointer bg-background-100 border border-background-200/70"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={`布丁漫画韩漫索引 — ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 flex items-center justify-between">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2">
                  {item.tag && (
                    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  )}
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}部</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}